export const HomeActions = {
  CHANGE_SIDE_BAR: "CHANGE_SIDE_BAR",
  SAVE_LIST_HOTEL: "SAVE_LIST_HOTEL",
  SAVE_DATA_HOTEL_DETAILS: "SAVE_DATA_HOTEL_DETAILS",
  SAVE_DATA_ROOM_DETAILS: "SAVE_DATA_ROOM_DETAILS",
  SAVE_DATA_PROFILE: "SAVE_DATA_PROFILE",
  SAVE_LIST_VOUCHER_BY_ACCOUNT_ID: "SAVE_LIST_VOUCHER_BY_ACCOUNT_ID",
};

export const PartnerActions = {
  DATA_CHART: "DATA_CHART",
  TOTAL_BOOKINGS: "TOTAL_BOOKINGS",
  TOTAL_REVIEWS: "TOTAL_REVIEWS",
};

export const AdminActions = {
  TOTAL_BOOKINGS: "TOTAL_BOOKINGS",
  TOTAL_ACCOUNT: "TOTAL_ACCOUNT",
  TOTAL_REVENUES: "TOTAL_REVENUES",
  TOP_USERS: "TOP_USERS",
  TOTAL_POST: "TOTAL_POST",
};
